import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Paper, Typography } from '@material-ui/core';
import useStyle from './style';
import Context from './../Context';
import { SyncIcon } from 'components/Icons';

interface Props {
  colaboradores: number;
  presentes: number;
  className?: string;
}

export default function ({
  colaboradores,
  presentes,
  className
}: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const {atualizarPresencas, atualizandoPresencas} = useContext(Context);

  return (
    <Grid container spacing={3} className={ className || '' }>
      <Grid item xs={12} sm={12} md={3}>
        <Paper className={classes.cartao}>
          <Typography className={classes.label}>
            {t('ConvocadosAssessor.totalConvocados')}
          </Typography>
          <Typography className={classes.value}>{atualizandoPresencas ? '-' : presentes}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={3}>
        <Paper className={classes.cartao}>
          <Typography className={classes.label}>
            {t('ConvocadosAssessor.totalColaboradores')}
          </Typography>
          <Typography className={classes.value}>{atualizandoPresencas ? '-' : colaboradores}</Typography>
        </Paper>
      </Grid>
      <Grid item xs={12} sm={12} md={6} container justify="flex-end" alignItems="center">
        <Button
          variant="text"
          color="primary"
          onClick={() => atualizarPresencas()}
          endIcon={<SyncIcon animated={atualizandoPresencas} />}
          disabled={atualizandoPresencas}
        >
          <Typography component="p" className={classes.syncLabel}>
            {t('AssembleiaAssessorRoute.buttonAtualizarParticipantes')}
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
}
